import React from 'react';
import { SvgIconProps } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import FactoryOutlinedIcon from '@mui/icons-material/FactoryOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import SatelliteAltOutlinedIcon from '@mui/icons-material/SatelliteAltOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';

/**
 * Shared icon + accent presets for export databases. The DB stores the icon
 * *key* (a short string) and the accent as a hex string, so the card and the
 * create modal render from the same source of truth.
 */
export const DATABASE_ICONS: Record<
  string,
  React.ComponentType<SvgIconProps>
> = {
  inventory: Inventory2OutlinedIcon,
  rocket: RocketLaunchOutlinedIcon,
  flight: FlightOutlinedIcon,
  memory: MemoryOutlinedIcon,
  shield: ShieldOutlinedIcon,
  science: ScienceOutlinedIcon,
  bolt: BoltOutlinedIcon,
  factory: FactoryOutlinedIcon,
  public: PublicOutlinedIcon,
  precision: PrecisionManufacturingOutlinedIcon,
  satellite: SatelliteAltOutlinedIcon,
  category: CategoryOutlinedIcon,
};

export const DATABASE_ICON_KEYS = Object.keys(DATABASE_ICONS);
export const DEFAULT_DATABASE_ICON = 'inventory';

// Mirrors the spec §2.5 chart/series palette so colors stay on-brand.
export const ACCENT_PALETTE = [
  '#4895ef',
  '#22a549',
  '#f59e0b',
  '#7c3aed',
  '#dc2626',
  '#14b8a6',
];
export const DEFAULT_ACCENT = '#4895ef';

export const getDatabaseIcon = (
  key: string | null | undefined,
): React.ComponentType<SvgIconProps> =>
  (key && DATABASE_ICONS[key]) || DATABASE_ICONS[DEFAULT_DATABASE_ICON];
